import { Link as MuiLink, Table, TableHead, TableBody, TableCell, TableRow } from '@mui/material'
import { Rule } from 'api/rule'
import { Link } from 'react-router-dom'
import { timeFormat } from 'utils/format'
import { getReportType } from 'utils/setting'

export default function RuleList({ list }: { list: Rule[] }) {
  return (
    <div>
      <Table size="small" sx={{ mt: 2, minWidth: 600 }}>
        <TableHead data-testid="table-head-operation-rule-settings">
          <TableRow sx={{ '& th': { backgroundColor: 'grey.200' } }}>
            <TableCell>文書タイプ名</TableCell>
            <TableCell>グループ</TableCell>
            <TableCell>登録日時</TableCell>
          </TableRow>
        </TableHead>
        <TableBody data-testid="table-body-operation-rule-settings">
          {(list || []).map((rule) => (
            <TableRow key={`${rule.subGroup}${rule.documentType}`}>
              <TableCell component="th" scope="row">
                <MuiLink
                  color="inherit"
                  underline="always"
                  component={Link}
                  to="edit"
                  state={{ rule /* is not url safe */ }}
                >
                  {getReportType(rule.documentType)} : {rule.documentTypeName}
                </MuiLink>
              </TableCell>
              <TableCell>{rule.subGroup}</TableCell>
              <TableCell>{rule.createTime ? timeFormat(rule.createTime) : '-'}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}
